export const {
  BUSINESS_ID_LENGTH = 6,
  DEFAULT_TIME_RANGE = "09:00-17:00",
  UPDATE_BANK_DETAILS = "Update bank details",
  UNLINK_WHATSAPP_ACCOUNT = "Unlink WhatsApp Business Account",
  ALLOWED_IMAGE_FORMATS = "image/jpeg, image/png, image/webp, image/jpg, image/heic",
  ALLOWED_DOCUMENT_FORMATS = "application/pdf",
  YEARLY_SUBSCRIPTION_AMOUNT = 5999,

  ERROR_MESSAGE_BUSINESS_SAVE_FAILED = "Failed to save business details. Please try again.",
  ERROR_MESSAGE_BUSINESS_HOLIDAYS_DATE_RANGE = "End time must be after start time",
  ERROR_MESSAGE_PAYMENT_FAILED = "Payment failed. Please try again. Contact support for help",
  ERROR_MESSAGE_EMPTY_SERVICE = "At least one service must be provided",
  ERROR_MESSAGE_OTP = "Please enter valid OTP!",
  ERROR_MESSAGE_USER_NOT_FOUND_USE_EMAIL = "User not found. Please use email for login.",
  ERROR_MESSAGE_LOGIN_WITH_EMAIL = "Please use email for login.",
  ERROR_MESSAGE_SUBSCRIPTION_EXPIRED = "Your subscription is expired. Subscribe to get the access back.",

  SUCCESS_MESSAGE_CLIENT_ADD = "Client added!",
  SUCCESS_MESSAGE_INVOICE_DOWNLOAD = "Invoice downloaded!",

  URL_VALIDATION_MESSAGE_SUCCESS = "\u2713 Available",
  URL_VALIDATION_MESSAGE_ERROR = "\u2715 Not available",

  REQUIRED_ERROR_NAME = "Name is required",
  REQUIRED_ERROR_FULL_NAME = "Full name is required",
  REQUIRED_ERROR_BUSINESS_NAME = "Business name is required",
  REQUIRED_ERROR_PHONE = "Phone number required",
  REQUIRED_ERROR_EMAIL = "Email is required",
  ERROR_MEMBER_ALREADY_EXISTS = "This member already exists",
  REQUIRED_ERROR_ROLE = "Role is required",
  REQUIRED_ERROR_OTP = "Enter OTP",
  REQUIRED_ERROR_DESCRIPTION = "Description is required",
  REQUIRED_ERROR_PRICE = "Price is required",
  REQUIRED_ERROR_VALID_PRICE = "Valid price is required",
  REQUIRED_ERROR_STOCK = "Stock is required",
  REQUIRED_ERROR_SKU = "SKU is required",
  REQUIRED_ERROR_TEMPLATE_NAME = "Template name is required",
  REQUIRED_ERROR_TEMPLATE_IMAGE = "Template image is required",
  REQUIRED_ERROR_BUSINESS_TYPE = "Business type is required",
  REQUIRED_ERROR_CONTACT_NUMBER = "Contact number is required",

  VALIDATION_ERROR_MIN_NAME_LENGTH = "Minimum 3 characters required",
  VALIDATION_ERROR_MIN_FULL_NAME_LENGTH = "Full name must be at least 3 characters",
  VALIDATION_ERROR_MIN_DESCRIPTION_LENGTH = "Minimum 3 characters required",
  VALIDATION_ERROR_PHONE = "Enter a valid phone number",
  VALIDATION_ERROR_PHONE_DIGIT_ONLY = "Phone number must contain only digits",
  VALIDATION_ERROR_OTP = "OTP must contains 6 digits",
  VALIDATION_ERROR_NAME_FORMAT = "Template name must contain only lowercase letters and underscores, and start with a letter",
  VALIDATION_ERROR_BODY_REQUIRED = "Body is required",
  INVALID_EMAIL = "Invalid email address",
  INVALID_NAME = "Invalid name",
  INVALID_PHONE = "Invalid phone number",
  INVALID_OTP = "Invalid OTP",
  VALIDATION_ERROR_VARIABLES_SEQUENTIAL = "Variables must be sequential numbers starting from 1",
  VALIDATION_ERROR_VARIABLES_ADJACENT = "Variables cannot be placed directly next to each other",
  VALIDATION_ERROR_VARIABLES_NAME = "Variable name can't contain only number",
  VALIDATION_ERROR_VARIABLES_NUMBER = "Variable must be a number",
  VALIDATION_ERROR_VARIABLES_EMPTY = "Variable name can't be empty",
  VALIDATION_ERROR_CONTACT_NUMBER = "Contact number must contain between 4 and 15 digits",
  VALIDATION_ERROR_ALTERNATE_CONTACT_NUMBER = "Alternate contact number must contain between 4 and 15 digits",
  VALIDATION_ERROR_ALTERNATE_CONTACT_NUMBER_SAME_AS_CONTACT_NUMBER = "Alternate contact number cannot be the same as contact number",

  REQUIRED_ERROR_BUTTON_TEXT = "Button text is required",
  REQUIRED_ERROR_BUTTON_URL = "Website URL is required",
  REQUIRED_ERROR_BUTTON_PHONE = "Phone number is required",
  VALIDATION_ERROR_BUTTON_TEXT_MIN = "Button text must be at least 3 characters",
  VALIDATION_ERROR_INVALID_WEBSITE_URL = "Please enter a valid website URL",
  VALIDATION_ERROR_INVALID_PHONE_NUMBER = "Please enter a valid phone number",

  FB_LOGIN_SCRIPT_LINK = "https://connect.facebook.net/en_US/sdk.js",
  URL_COPIED_TO_CLIPBOARD = "URL copied to clipboard!",
  FAILED_TO_COPY_URL = "Failed to copy URL",
} = {};
